// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "button-229l_";
var _3 = "container-3tEWm";
var _4 = "text-wVxwL";
export { _1 as "__esModule", _2 as "button", _3 as "container", _4 as "text" }
export default { "__esModule": _1, "button": _2, "container": _3, "text": _4 }
